import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "./guards/auth.guard";
import { ExternalQuotesProviderGuard } from "./guards/external-quotes-provider.guard";

const routes: Routes = [
  {
    // Legacy Cetelem/Inbursa portal: keeps its dedicated endpoint. Matched before `:provider/clientes`.
    path: "inbursa/clientes",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./features/cetelem-external-quotes/cetelem-external-quotes.module").then(
        (m) => m.CetelemExternalQuotesModule
      ),
  },
  {
    // Generic multi-provider portal (Santander and future alliances), gated by an allowlist guard.
    path: ":provider/clientes",
    canActivate: [AuthGuard, ExternalQuotesProviderGuard],
    loadChildren: () =>
      import("./features/cetelem-external-quotes/cetelem-external-quotes.module").then(
        (m) => m.CetelemExternalQuotesModule
      ),
  },
  {
    path: "",
    canActivate: [AuthGuard],
    loadChildren: () => import("./features/quotation/quotation.module").then((m) => m.QuotationModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
